<p style="font-size: small; font-style: italic; color: var(--red-inforius)">
  {{ errorMessage() ?? ("GLOBAL.ERRORS.REQUIRED_FIELD" | translate) }}
</p>
